import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../service/api.service';

@Component({
  selector: 'app-xultophy-params2',
  templateUrl: './xultophy-params2.component.html',
  styleUrls: ['../../../theme.scss']
})
export class XultophyParams2Component implements OnInit {

  constructor(public api: ApiService) { }

  ngOnInit() {
  }

}
